
// At this time the DebugResponse is only stored locally but the idea is that we can
//     retrieve these from the back-end so we can persist accross visits
export class DebugResponse {
    debugEnabled: boolean = false;
}
